module.exports = __webpack_public_path__ + "ui-static/img/empty_dark.10e73a19.svg";